import React from "react";

const Stat_Population_Proportion_Estimation = () => {
  return (
    <div>
      <h1>Stat Population Proportion Estimation</h1>
    </div>
  );
};

export default Stat_Population_Proportion_Estimation;
